import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { CountryFlag } from 'widgets/bussiness/country-flag';
import { StudentDto } from 'stores/students/student-model';
import { IdentityService, Roles } from 'services/identity-service';
import { resolve } from 'inversify-react';
import { openInNewWindow } from 'utils/useful-functions';

interface TailwindStudentListProps extends WithTranslation {
  onStudentRemove?: (value: StudentDto) => void;
  students?: StudentDto[];
  canRemove?: boolean;
  pocLocations?: string[];
}

export interface TailwindStudentListState {
  isAdminPocInstructorOrPlanner: boolean;
  isPoc: boolean;
}

class TailwindStudentList extends Component<TailwindStudentListProps, TailwindStudentListState> {
  constructor(props) {
    super(props);
    this.state = {
      isAdminPocInstructorOrPlanner: false,
      isPoc: false
    };
  }
  @resolve(IdentityService)
  private identityService: IdentityService;

  componentDidMount() {
    if (this.identityService.isInRole(Roles.Employee)) this.setState({ isAdminPocInstructorOrPlanner: false, isPoc: false });
    else if (IdentityService.isAdminPocPlannerOrInstructor) {
      this.setState({ isAdminPocInstructorOrPlanner: true });
      if (this.identityService.isInRole(Roles.PoC)) this.setState({ isPoc: true });
    }
  }

  private onStudentClicked(id: string) {
    openInNewWindow(`./employee-page/${id}`);
  }

  private onStudentRemove(student: StudentDto) {
    if (this.props.onStudentRemove) this.props.onStudentRemove(student);
  }

  render() {
    return (
      <div onClick={() => {}} className={`bg-white shadow p-4 mt-4 overflow-y-auto transition-all duration-300 max-h-[300px]`}>
        <>
          {this.props.students.map((student, indx) => {
            return (
              <>
                <div className="border-l-4 p-3 mb-2 cursor-pointer shadow-md">
                  <div className="flex flex-row justify-between items-center w-full">
                    <div className="flex flex-col min-w-0">
                      <h4 className="text-black-600 font-semibold truncate">{`${student.firstName}  ${student.lastName}`}</h4>
                      <p className="text-xs text-gray-500 truncate">{student.userName}</p>
                      <p className="text-sm truncate">
                        {student.location ? (
                          <>
                            <CountryFlag countryName={student.location.countryName} />
                            {` ${student.location.location}`}
                          </>
                        ) : (
                          '-'
                        )}
                      </p>
                    </div>
                    <div className="flex flex-row gap-2 ml-4 shrink-0">
                      {this.state.isAdminPocInstructorOrPlanner &&
                        (!this.state.isPoc ||
                          (this.props.pocLocations &&
                            this.props.pocLocations.length > 0 &&
                            this.props.pocLocations.any(x => x === student.location.id))) && (
                          <div key={`${indx}_eye`} onClick={() => this.onStudentClicked(student.id)}>
                            <svg
                              className="w-6 h-6 text-gray-800 dark:text-white"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M10 11h2v5m-2 0h4m-2.592-8.5h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                              />
                            </svg>
                          </div>
                        )}

                      {this.props.canRemove && (
                        <div key={`${indx}_remove`} onClick={() => this.onStudentRemove(student)}>
                          <svg
                            className="w-6 h-6 text-gray-800 dark:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <path
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                            />
                          </svg>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </>
      </div>
    );
  }
}

export default withTranslation()(TailwindStudentList);
